import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { UserService } from 'src/app/infrastructure/services/user.service';
import { CurrentUser } from '@model/user/current-user.model';

@Injectable({
  providedIn: 'root'
})
export class UserGateway {
  private readonly userService = inject(UserService);

  getUser(): Observable<CurrentUser> {
    return this.userService.getUser().pipe(
      map((response) => ({
        username: response.username,
        dni: response.dni
      }))
    );
  }
}
